import { render, staticRenderFns } from "./lhcOrderTable.vue?vue&type=template&id=ecdb2646&scoped=true"
import script from "./lhcOrderTable.vue?vue&type=script&lang=ts"
export * from "./lhcOrderTable.vue?vue&type=script&lang=ts"
import style0 from "./lhcOrderTable.vue?vue&type=style&index=0&id=ecdb2646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdb2646",
  null
  
)

export default component.exports